/** @jsx jsx */
import React, { useContext, useState, useCallback } from 'react'
import { getEnvConfig, getPermitActions, getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { rowHeaderRender, hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { jsx } from '@emotion/core'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { dateCol, intCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { Button, DatePicker, Input, message, Upload, Icon } from 'antd'
import { getSwitchBoardHNP, getAuthorization, getCredentials } from 'api/pgads'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import qs from 'querystring'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

const HNP = ({ envConfig, actionPermits, apiTargetInfo }) => {
  const { authGodMode } = envConfig
  const [importResult, setImportReult] = useState([])

  const importPermisiion = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.SWITCHBOARD_IMPORT],
    matchAny: true,
  })

  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState([])
  const retrieve = ({ date = selectedDate }) => {
    setSpinning(true)
    getSwitchBoardHNP(apiTargetInfo)(date).fork(setError, data => {
      setData(data)
      setSpinning(false)
    })
  }

  const url = ft =>
    `${apiTargetInfo.baseUrl}/switchboard/import-hnp?${qs.stringify({
      fileType: ft,
    })}`
  const fileProps = {
    name: 'file',
    action: url('hnp'),
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const onFileUploadChange = useCallback(
    info => {
      if (info.file.status === 'done') {
        setSpinning(false)
        message.success(`${info.file.name} file uploaded successfully`)
        // setImportResponse(info.file.response)
        // message.info(info.file.response)
        setImportReult(info.file.response)
        // retrieveData()
      } else if (info.file.status === 'error') {
        setSpinning(false)
        // reportError(info.file.response)
        // onError(info)
        setError(info.file.response)
        if (info.file.response.appExceptionId !== 100)
          message.error(`${info.file.name} file have invalid data`)
      }
    },
    [setError, setSpinning]
  )

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <JcTmpErrorDialog
        visible={importResult.length > 0}
        errors={importResult}
        closeErrorPrompt={_ => setImportReult([])}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '250px',
          }}
        >
          HNP
        </Title>
        <DatePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            if (d && d.isValid) {
              setSelectedDate(d)
              retrieve({ date: d })
            }
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={_ => retrieve({ date: selectedDate })}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>

        <Filler />
        {importPermisiion && (
          <Upload
            {...fileProps}
            onChange={data => {
              setSpinning(true)
              onFileUploadChange(data)
            }}
            multiple={false}
            showUploadList={false}
          >
            <Button>
              <Icon type="upload" /> Import
            </Button>
          </Upload>
        )}

        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={240}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Grid
              fuzzyFilter={fuzzyFilter}
              sortEnabled={false}
              data={data}
              headers={IfSwbdHnpHeaders}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: false,
                rowHeaderRender,
                height: height - 50,
                width: width - 100,
                headerRowHeight: 30,
              })}
              sort={[
                {
                  ident: 'transdate',
                  display: 'Transdate',
                  isKey: true,
                  sortOrder: 'asc',
                },
                {
                  ident: 'transhour',
                  display: 'Transhour',
                  isKey: true,
                  sortOrder: 'asc',
                },
              ]}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  apiTargetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(HNP)

const IfSwbdHnpHeaders = [
  dateCol({
    ident: 'transdate',
    display: 'Transaction Date',
    isKey: true,
    width: 150,
  }),
  intCol({
    ident: 'transhour',
    display: 'Transaction Hour',
    isKey: true,
    width: 150,
  }),
  intCol({
    ident: 'genWh',
    display: 'Generator Watt Hours(MWH) Last Hour',
    isFiltered: true,
    width: 250,
  }),
  intCol({
    ident: 'unitAuxWh',
    display: 'Unit Aux Watt Hours(MWH) Last Hour',
    isFiltered: true,
    width: 250,
  }),
  intCol({
    ident: 'startupWh',
    display: 'Start-Up Watt Hours (MWH)Last Hour',
    isFiltered: true,
    width: 250,
  }),
  intCol({
    ident: 'netLoad',
    display: 'Net Load (MWH)',
    isFiltered: true,
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
// .map(d =>
//   d.type === 'num' && d.ident !== 'transhour'
//     ? { ...d, displayFormat: '000,000,000' }
//     : d
// )
